export { default as ResultsPane } from "./ResultsPane.container"
export { 
  default as resultsReducer,
  customizedFieldsSelector,
  defaultFieldsSelector,
  setResults,
  resultsSelector,
  RESULTS_KEY 
} from "./ResultsPane.module"